import {triggerDocumentEvent} from "@js/globalFunctions/events";

export function updateDateRangeValue()
{
	const value = dataholder.dateRangeDatePicker.getValue();
	const matches = value.match(/([0-9]{2}-[0-9]{2}-[0-9]{4})/g);
	if(matches === null || matches.length !== 2)
	{
		searchParameters.removeParameter('dateRange')
	}
	else
	{
		searchParameters.setParameter('dateRange', matches.join(' - '))
	}
	triggerDocumentEvent('searchChanged');
}
